const ON_CHANGE_DEBOUNCE_TIMER = 150; // Tibetia: Warenkorb-Mengen schneller übernehmen (Dawn-Standard 300)

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
